var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 8.00768C1 7.22612 1.40558 6.50054 2.07132 6.09112L9.82132 1.32487C10.5442 0.88028 11.4558 0.88028 12.1787 1.32487L19.9287 6.09112C20.5944 6.50054 21 7.22612 21 8.00768V15.75C21 17.5449 19.5449 19 17.75 19H4.25C2.45508 19 1 17.5449 1 15.75V8.00768Z",
    fill: "#014EA4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 7.75C4 6.7835 4.7835 6 5.75 6H16.25C17.2165 6 18 6.7835 18 7.75V12.25C18 13.2165 17.2165 14 16.25 14H5.75C4.7835 14 4 13.2165 4 12.25V7.75Z",
    fill: "url(#paint0_linear_1_508)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 8C1 8.85957 1.54226 9.59249 2.30337 9.87533L10.1059 13.0796C10.375 13.2142 10.6786 13.29 11 13.29C11.2639 13.29 11.5158 13.2389 11.7465 13.1461H11.7735L13.3287 13.2567C14.8337 13.3638 16 14.6159 16 16.1247C16 17.7127 14.7127 19 13.1247 19H4.25C2.45507 19 1 17.545 1 15.75V9.34009V8Z",
    fill: "#1493DF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 8C1 8.85957 1.54226 9.59249 2.30337 9.87533L10.1059 13.0796C10.375 13.2142 10.6786 13.29 11 13.29C11.2639 13.29 11.5158 13.2389 11.7465 13.1461H11.7735L13.3287 13.2567C14.8337 13.3638 16 14.6159 16 16.1247C16 17.7127 14.7127 19 13.1247 19H4.25C2.45507 19 1 17.545 1 15.75V9.34009V8Z",
    fill: "url(#paint1_radial_1_508)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 8C1 8.85957 1.54226 9.59249 2.30337 9.87533L10.1059 13.0796C10.375 13.2142 10.6786 13.29 11 13.29C11.2639 13.29 11.5158 13.2389 11.7465 13.1461H11.7735L13.3287 13.2567C14.8337 13.3638 16 14.6159 16 16.1247C16 17.7127 14.7127 19 13.1247 19H4.25C2.45507 19 1 17.545 1 15.75V9.34009V8Z",
    fill: "url(#paint2_linear_1_508)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 8C1 8.85957 1.54226 9.59249 2.30337 9.87533L10.1059 13.0796C10.375 13.2142 10.6786 13.29 11 13.29C11.2639 13.29 11.5158 13.2389 11.7465 13.1461H11.7735L13.3287 13.2567C14.8337 13.3638 16 14.6159 16 16.1247C16 17.7127 14.7127 19 13.1247 19H4.25C2.45507 19 1 17.545 1 15.75V9.34009V8Z",
    fill: "url(#paint3_linear_1_508)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.6966 9.87533C20.4577 9.59249 21 8.85957 21 8V9.34009V15.75C21 17.545 19.5449 19 17.75 19H8.09534C6.93811 19 6 18.0619 6 16.9047C6 16.0549 6.51327 15.2893 7.29936 14.9664L19.6966 9.87533Z",
    fill: "url(#paint4_linear_1_508)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_508",
    x1: 8.66667,
    y1: 6,
    x2: 10.9126,
    y2: 14.0245,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.320647,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C2DEF2"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_1_508",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(8 17.5) rotate(90) scale(3.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#014EA4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#014EA4",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1_508",
    x1: 9.5,
    y1: 15.5,
    x2: 8.5,
    y2: 13.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#014EA4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#014EA4",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1_508",
    x1: 4,
    y1: 15.5,
    x2: 9.5,
    y2: 15.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1493DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1493DF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1_508",
    x1: 5.84735,
    y1: 15.6148,
    x2: 21.0001,
    y2: 15.6148,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#50E6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.653509,
    stopColor: "#43D4F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#28AFEA"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/Email.9e3920ed86d7b81c013718b68f98dae1.svg";
export { ForwardRef as ReactComponent };